export default "__VITE_ASSET__Dn2CX9d3__"